import { formatNumberDisplayValue, maxDecimalValue } from '@/utils/numberUtil';
import { Translations } from '@/utils/translations/Translations';
export const italianTranslations: Translations = {
  admin: {
    applicationCyclesCurrent: 'Cicli di candidatura correnti',
    applicationCyclesHeader: 'Cicli di candidatura',
    applicationCyclesPast: 'Cicli di candidatura passati',
    applicationCyclesUpcoming: 'Prossimi cicli di candidatura',
    applicationsHeader: 'Domande',
    emailsHeader: 'Email',
    tabEmailActivity: 'Attività email',
    tabSendEmail: 'Invia email',
    tabTcowMassApproval: 'Approvazione di massa TCOW',
  },
  address: {
    addAddress2: '+ Appartamento/Interno/Unità',
    labelCity: 'Città',
    labelCountry: 'Paese',
    labelCounty: 'Contea',
    labelState: 'Stato',
    labelStreetAddress: 'Indirizzo',
    labelStreetAddress2: 'Appartamento/Interno/Unità',
    labelZipCode: 'Codice',
  },
  applicationBody: {
    approveApplicationButton: 'Approva domanda',
    tooltipNextStandard: 'Standard successivo',
    tooltipPreviousStandard: 'Standard precedente',
    tooltipRequiredQuestions: 'Compilare prima tutte le domande obbligatorie',
    resubmitButton: 'Reinvia',
    sendBackToApplicantWithComments: 'Inviare nuovamente la domanda al richiedente con i commenti',
    starApprovalButton: 'Approva stella',
    starRemovalButton: 'Rimuovi stella',
    submitButton: 'Invia',
    submitMessage: 'Invio in corso...',
    tooltipApproveSendsToNextReviewStage:
      'Facendo clic su "Approva" la domanda viene inviata alla fase di revisione successiva.',
    tooltipApproveBeforeSubmit:
      'Assicurati che la revisione sia completa prima di fare clic su "Approva".',
    tooltipApproveWithUnresolvedComments:
      'Risolvi tutti i commenti prima di approvare la domanda. I commenti non risolti si trovano negli standard evidenziati in giallo nella barra di avanzamento.',
    tooltipSendBackRequiresComment:
      'Inserisci un commento per questa fase di revisione prima di rinviare la domanda al richiedente.',
  },
  applicationHeader: {
    headerViewingApplication: 'Visualizzazione domanda per ',
    messageRequiredQuestions: 'Compilare tutte le domande obbligatorie',
    missingRequiredQuestions: 'Domande obbligatorie mancanti',
    reviewerComments: 'Commenti del Revisore',
    standardCompleted: 'Terminato',
    starAwarded: 'Stella assegnata',
    yearsRecognized: (year: number) => `Candidatura per l’anno ${year} di riconoscimento`,
  },
  applicationPreview: {
    backToAdmin: 'Torna ad Admin',
    previewModeMessage:
      'La modalità anteprima è attiva. Le modifiche in questa visualizzazione non vengono salvate.',
    programLabel: 'Programma',
    unknownValue: 'Sconosciuto',
  },
  common: {
    ariaSaved: 'Salvato',
    ariaSaveFailed: 'Salvataggio non riuscito',
    ariaSaving: 'Salvataggio in corso',
    buttonPost: 'Pubblica',
    buttonReactivate: 'Riattiva',
    buttonResolve: 'Risolvi',
    defaultConfirmationModalText: {
      header: 'Conferma azione',
      confirmationMessage: 'Sei sicuro di voler eseguire questa azione?',
      cancelButtonText: 'Annulla',
      confirmationButtonText: 'Conferma',
      successMessage: 'Eliminazione completata con successo!',
    },
    buttonSaving: 'Salvataggio in corso...',
    buttonSave: 'Salva',
    buttonDelete: 'Elimina',
    buttonUpdate: 'Aggiorna',
    characterCountRemaining: (remaining: number, max: number) =>
      `${remaining}/${max} caratteri rimanenti`,
    commentResolved: 'Commento risolto',
    error: 'Errore',
    genericError: 'Si è verificato un errore. Per favore, riprova.',
    messageCommentAddedSuccessfully: 'Commento aggiunto con successo!',
    messageCommentAddFailed: 'Impossibile aggiungere il commento',
    messageCommentCannotBeEmpty: 'Il commento non può essere vuoto!',
    messageCommentTooLong: 'Il commento è troppo lungo!',
    messageGrowthAwardApprovalSuccess: 'Approvazione riuscita!',
    messageGrowthAwardApproveProblem:
      "Si è verificato un problema durante l'approvazione del Growth Award. Riprova più tardi.",
    messageGrowthAwardApproving: 'Approvazione Growth Award in corso ...',
    messageGrowthAwardCategoriesFetchError:
      'Errore durante il recupero delle categorie del Growth Award.',
    messageGrowthAwardCommentRequired:
      'Inserisci un commento prima di rinviare la domanda al richiedente.',
    messageGrowthAwardReturnSuccess: 'Rinvio riuscito!',
    messageGrowthAwardSendBackProblem:
      'Si è verificato un problema durante il rinvio della domanda.',
    messageGrowthAwardSendingBack: 'Invio del Growth Award al richiedente in corso...',
    messageGrowthAwardSubmitted: 'Domanda Growth Award inviata!',
    messageGrowthAwardSubmitting: 'Invio Growth Award in corso ...',
    messageGrowthAwardSubmitProblem:
      "Si è verificato un problema durante l'invio del Growth Award.",
    noMatch: 'Nessun risultato trovato.',
    placeholderPostComment: 'Pubblica un commento',
    previewInputPlaceholder: 'Input anteprima (non salvato)',
    previewWorkflowSpecificDataNotice:
      'Questa domanda usa dati specifici del flusso di lavoro in produzione. La modalità anteprima acquisisce solo testo locale e non chiama le API.',
    buttonContinue: 'Continua',
    buttonCancel: 'Annulla',
    buttonClose: 'Chiudi',
    requiredIndicatorTitle: 'obbligatorio',
    statusApplicationApproved: 'Domanda approvata',
    statusApplicationReturned: 'Domanda rinviata',
    statusApplicationSubmitted: 'Domanda inviata',
    statusApproving: 'Approvazione...',
    statusReturning: 'Rinvio in corso...',
    statusUpdating: 'Aggiornamento ...',
    tooltipSubmitGrowthAward: 'Fai clic per inviare la domanda Growth Award.',
    tooltipRetrySave: 'Riprova il salvataggio',
    tooltipSaveFailed: 'Salvataggio non riuscito',
  },
  contact: {
    confirmationModal: {
      header: 'Rimuovi contatto',
      confirmationMessage:
        'Sei sicuro di voler rimuovere questo contatto? Questa azione non può essere annullata.',
      confirmationButtonText: 'Rimuovi contatto',
      successMessage: 'Contatto rimosso con successo!',
    },
    buttonAdd: 'Aggiungi nuovo contatto',
    buttonChange: 'Modifica contatto',
    buttonCreate: 'Seleziona o crea un nuovo contatto',
    buttonSave: 'Salva contatto',
    buttonUpdate: 'Aggiorna contatto',
    createContact: 'Crea nuovo contatto',
    editContact: 'Modifica contatto',
    editWarning: (appYear: string) =>
      `Stai per modificare i dettagli di un contatto esistente. Queste modifiche verranno aggiornate ovunque questo contatto sia utilizzato nelle applicazioni ${appYear}.`,
    invalidEmail: 'Inserisci un indirizzo e-mail valido.',
    invalidZipCode: 'Inserisci un codice postale valido.',
    invalidPhoneNumber: 'Numero di telefono non valido',
    requiredFieldSuffix: 'obbligatorio',
    labelCity: 'Città',
    labelCountry: 'Paese',
    labelEmail: 'E-mail',
    labelFirstName: 'Nome',
    labelLastNameLabel: 'Cognome',
    labelName: 'Nome',
    labelPhoneNumber: 'Numero',
    labelStreetAddress2Label: 'Indirizzo 2',
    labelStreetAddressLabel: 'Indirizzo',
    labelTitle: 'Titolo',
    labelWhatsApp: 'WhatsApp o altro numero di telefono',
    labelZipCode: 'Codice postale',
    messageContactRemoved: 'Contatto rimosso!',
    messageContactSaveFailed: 'Impossibile salvare il contatto.',
    messageMaximum: 'Hai raggiunto il numero massimo di contatti per questa sezione.',
    messageSaved: 'Contatto salvato!',
    placeHolderPhoneNumber: 'Inserisci il numero di telefono',
  },
  dashboard: {
    accessToolkit: 'Accedi al toolkit',
    accessToolkitPendingApproval: 'Disponibile una volta approvata la tua domanda',
    download: 'Scarica',
    downloadTooltip: 'Scarica e stampa domanda',
    fieldApplication: 'Domanda',
    fieldApplicationCycle: 'Ciclo di candidatura',
    fieldStatus: 'Stato',
    fieldSubmittedBy: 'Inviato da',
    growthAwardCardHeader: 'Candidati al Growth Award',
    growthAwardCardPendingLabel: (programName: string) =>
      `La candidatura al Growth Award può essere avviata una volta inviata la candidatura a ${programName}.`,
    growthAwardCardStartButton: 'Inizia la candidatura al Growth Award',
    labelApplication: 'CANDIDATURA',
    labelCreateApplication: 'Crea nuova applicazione',
    labelPastApplications: 'Applicazioni',
    messageCreateApplication: 'Creazione di una nuova applicazione ...',
    messageNoApplications: 'Nessuna candidatura',
    portalClosedInformation: (latestAppCycleYear: string, nextOpenDate?: string | null) =>
      `La domanda per il ciclo ${
        latestAppCycleYear != null ? latestAppCycleYear + ' ' : ''
      }è attualmente chiusa. ${
        nextOpenDate != null ? `Le domande si apriranno il ${nextOpenDate}. ` : ''
      }Grazie.`,
    selectPartner: 'Seleziona un partner',
    stateQuestionsCardHeader: 'IL TUO STATO RICHIEDE INFORMAZIONI AGGIUNTIVE',
    stateQuestionsCardPendingLabel:
      'Le domande specifiche dello stato possono iniziare una volta inviata una candidatura Tree City USA.',
    stateQuestionsCardStartButton: 'Inizia domande sullo stato',
    viewApplication: 'Visualizza applicazione',
    viewApplicationHelperTextEnabled: 'Visualizza applicazione',
    viewApplicationHelperTextDisabled: 'Applicazione non disponibile',
    viewApplicationButton: 'Visualizza',
    growthAwardHeader: 'Premio crescita',
    growthAwardPendingLabel: 'In attesa',
    growthAwardStartButton: 'Inizia la candidatura al Growth Award',
    stateQuestionsHeader: 'Domande sullo stato',
    stateQuestionsPendingLabel: 'In attesa',
    stateQuestionsStartButton: 'Inizia domande sullo stato',
    exportEmailLabel: "Inserisci l'indirizzo email a cui inviare il file CSV",
    exportEmailAlreadyAdded: (email: string) =>
      `'${email}' è già stato aggiunto all'elenco dei destinatari dell'esportazione.`,
    exportEmailPlaceholder: 'Indirizzo email',
    exportErrorMessage: "Si è verificato un errore durante l'esportazione. Per favore riprova.",
    exportGenerating: 'Generazione in corso...',
    exportGenerateCsv: 'Genera CSV',
    exportIncludeQuestionResponses: 'Includi risposte alle domande',
    exportInvalidEmailAddress: (email: string) => `'${email}' non è un indirizzo email valido.`,
    exportMaxEmailsWarning: 'Puoi inviare un massimo di 5 email per esportazione.',
    exportModalTitle: 'Esporta dati',
    exportOptionalParams: 'Parametri opzionali',
    exportRequiredParams: 'Parametri obbligatori',
    exportSelectApplicationType: 'Seleziona il tipo di applicazione',
    exportSelectCounty: 'Seleziona la contea',
    exportSelectPartner: 'Seleziona il partner',
    exportSelectProgram: 'Seleziona il programma',
    exportSelectState: 'Seleziona lo stato',
    exportSuccessMessage: 'Esportazione riuscita! Controlla la tua email per il file CSV.',
    exportTypeGrowthAward: 'Domande per il premio crescita',
    exportTypeMainApplications: 'Domande principali',
    exportTypeStateQuestions: 'Domande sullo stato',
    loadingText: 'Caricamento...',
    messageCreateApplicationError:
      'Si è verificato un errore durante la creazione della domanda. Per favore riprova.',
    messageNoCycleFound: 'Nessun ciclo di candidatura trovato. Per favore riprova più tardi.',
    messageFetchApplicationsError:
      'Non è stato possibile caricare le candidature. Per favore riprova o aggiorna la pagina.',
  },
  dataUpload: {
    confirmationModal: {
      header: 'Elimina allegato',
      confirmationMessage:
        'Sei sicuro di voler eliminare questo allegato? Questa azione non può essere annullata.',
      confirmationButtonText: 'Elimina allegato',
      successMessage: 'Allegato eliminato con successo!',
    },
    errorURL: 'Inserisci un URL valido',
    helperSelectFile:
      'Clicca su Seleziona per cercare e scegliere un file sul tuo computer. Clicca su Salva per allegarlo alla tua candidatura. Assicurati che il nome del file sia unico. I formati di archiviazione compressi, ad esempio .zip, non sono supportati.',
    helperUrl:
      'Fornisci solo link a pagine web pubbliche e non a piattaforme di condivisione di documenti (ad esempio Google Docs o Dropbox). Se si tratta di un URL, assicurati di includere "http":// o "https":// come parte dell\'URL. Clicca su Salva per allegarlo alla tua candidatura.',
    labelAddFile: 'Aggiungi file',
    labelEventProof: 'Allega la prova del ',
    labelFile: 'File',
    labelURL: 'URL',
    labelSave: 'Salva',
    labelSaving: 'Salvataggio',
    labelSelectFile: 'Seleziona',
    labelUpload: 'Caricamento',
    messageDownload: 'Clicca per scaricare il PDF',
    messageFailed: 'Caricamento non riuscito.',
    messageSuccess: 'Caricamento riuscito!',
    placeholderURL: 'Inserisci un URL',
    errorFileSize: 'La dimensione del file supera il limite di 25 MB.',
    errorFileTypeUnsupported:
      'Questo tipo di file non è supportato. Carica un file diverso da .zip.',
    warningDuplicateFileSkipped:
      'Rilevato nome file duplicato. I file duplicati sono stati ignorati.',
    warningDuplicateUrlExists: 'Questo URL è già stato aggiunto.',
    labelTryAgain: 'Riprova',
    labelUploadedFile: 'File caricato',
    labelSavedUrl: 'URL salvato',
    labelGetPdfSummary: 'Ottieni riepilogo PDF',
    tooltipClearError: 'Cancella errore',
    tooltipOpen: 'Apri',
    tooltipDownload: 'Scarica',
    tooltipDelete: 'Elimina',
    ariaClearUploadError: 'Cancella errore di caricamento',
    ariaOpenAttachment: 'Apri allegato',
    ariaOpenUrlAttachment: 'Apri URL allegato',
    ariaDownloadAttachment: 'Scarica allegato',
  },
  deadlineBanner: {
    deadlineText: 'SCADENZA PER LA PRESENTAZIONE',
    stateReviewDeadlineText: 'Scadenza revisione statale',
  },
  decimalQuestion: {
    maxValueExceeded: `Il valore inserito deve essere compreso tra 0 e ${formatNumberDisplayValue(
      maxDecimalValue.toString(),
      'decimal'
    )}.`,
  },
  event: {
    confirmationModal: {
      header: 'Elimina contatto',
      confirmationMessage:
        'Sei sicuro di voler eliminare questo contatto? Questa azione non può essere annullata.',
      confirmationButtonText: 'Elimina contatto',
      successMessage: 'Evento eliminato con successo!',
    },
    buttonAddEvent: 'Aggiungi',
    celebration: 'Celebrazione',
    dateRangeError: 'Seleziona una data compresa tra {{minDate}} e {{maxDate}}.',
    eventName: "Nome dell'evento",
    helperEvent:
      "Per aggiungere un altro evento, clicca sul pulsante Aggiungi qui sotto. Per rimuovere un evento aggiuntivo, clicca sul pulsante Elimina sull'evento (devi avere almeno un evento).",
    labelName: "Quando è stato celebrato l'evento della tua comunità?",
    labelSubType: 'Che tipo di evento?',
    labelSubTypeOther: 'Descrivi altri tipi di "ricorrenza":',
    messageDelete: 'Eliminazione in corso...',
    messageSaved: 'Evento salvato!',
    other: 'Alt',
    summary: 'Riassumi',
    tooltipDelete: 'Clicca per rimuovere questo evento.',
    treeDay: "Giornata dell'albero",
    type: 'Tipo',
  },
  header: {
    application: 'APPLICAZIONE',
    dashboard: 'BACHECA',
    error: 'Errore',
    inactive: 'Utente inattivo',
    myaccount: 'Informazioni sull’account',
    mycontact: 'Informazioni di contatto',
    pending: 'IN ATTESA',
    pendingMessage:
      'Il tuo account è in attesa di convalida. Potrai procedere una volta che un amministratore avrà approvato la tua richiesta.',
    signedInAs: 'Accedi come',
    signup: 'REGISTRATI',
    statequestions: 'DOMANDE SULLO STATO',
    tooltipDashboard: 'Torna alla dashboard',
    tooltipLanguage: 'Cambia lingua',
    tooltipHelp: 'Aiuto',
    tooltipMyAccount: 'Il mio account',
    tooltipSignOut: 'Esci',
    tooltipUserManagement: 'Gestione utenti',
    usermanagement: 'GESTIONE UTENTI',
    instructionsTitle: 'Istruzioni',
    growthaward: 'PREMIO CRESCITA',
    tooltipStopImpersonation: 'Interrompi impersonificazione',
  },
  integerQuestion: {
    invalidInteger: 'Il valore inserito deve essere compreso tra 0 e 99.999.999.',
    labelSum:
      'La somma degli alberelli e delle piantine deve essere inferiore o uguale al numero totale di alberi piantati.',
  },
  multiCheckbox: {
    helper: 'Seleziona almeno una voce',
  },
  multiCheckbox3: {
    helperMaximum: 'Non più di 3 scelte',
  },
  myaccount: {
    accountSettings: 'Impostazioni account',
    characterlimit: (charLimit: number) => `Limite di ${charLimit} caratteri`,
    errorHelperText: 'Compila tutti i campi obbligatori',
    emailNewAccountHelperText:
      'Per registrare un nuovo indirizzo e-mail, è necessario creare un nuovo account.',
    myAccount: 'Il mio account',
    partnerDetails: (partnerName: string) => `Dettagli di ${partnerName}`,
    preferredlanguage: 'Qual è la tua lingua preferita?',
    primaryContactHeader: 'Informazioni sul contatto principale',
    titlerequired: 'Titolo obbligatorio',
    updatePrimaryContactError: 'Errore durante l’aggiornamento del contatto principale',
    updatePrimaryContactSuccess: 'Contatto principale aggiornato',
    updateUserContactSuccess: 'Contatto utente aggiornato',
    updateUserContactError: 'Errore durante l’aggiornamento del contatto utente',
    unsavedChangesBody: 'Hai modifiche non salvate. Vuoi abbandonarle e navigare altrove?',
    unsavedChangesTitle: 'Modifiche non salvate',
    buttonKeepEditing: 'Continua a modificare',
    buttonDiscardChanges: 'Abbandona modifiche',
    shippingContactHeader: 'Informazioni sul contatto di spedizione',
    tabAccountSettings: 'Impostazioni dell’account',
    tabPrimaryContact: 'Contatto principale',
    tabShippingAddress: 'Indirizzo di spedizione',
    errorUpdatingShippingContact: 'Errore durante l’aggiornamento del contatto di spedizione',
    shippingContactUpdated: 'Contatto di spedizione aggiornato',
  },
  partner: {
    other: 'Altro',
  },
  partnerUpdateModal: {
    saveAwards: 'Salva premi',
    saveContacts: 'Salva contatti',
    savePartnerInfo: 'Salva informazioni partner',
    tabContacts: 'Contatti',
    tabPartnerInfo: 'Informazioni partner',
    tabYearsAwarded: 'Anni premiati',
    titleEditPartnerDetails: 'Modifica dettagli partner',
    tooltipError: 'Errore',
    tooltipHasUnsavedChanges: 'Ci sono modifiche non salvate',
    tooltipSaved: 'Salvato',
    tooltipSaving: 'Salvataggio',
  },
  profileMenu: {
    addAccount: 'Aggiungi account',
    addAccountTooltip:
      'Questo è per le organizzazioni che partecipano a più programmi o che hanno più sedi e devono creare account separati per ciascuna.',
    manageAccount: 'Gestisci account',
    myAccount: 'Il mio account',
    signOut: 'Esci',
    admin: 'Amministrazione',
    userManagement: 'Gestione utenti',
  },
  signature: {
    buttonClear: 'Cancella',
    messageSaved: 'Firma salvata!',
    terms: 'Termini e condizioni',
    tooShortError: 'La firma è troppo corta. Per favore, disegna una firma più lunga.',
  },
  submitConfirmation: {
    title: 'Candidatura inviata',
    message: 'Grazie! La tua candidatura è stata inviata ed è ora in attesa di revisione.',
    reviewApplication: 'Rivedi candidatura',
    backToDashboard: 'Torna alla dashboard',
  },
  signup: {
    buttonSubmit: 'INVIA',
    checkContactShipping: "Uguale all'indirizzo del contatto principale",
    checkIncludeInDirectory:
      "Se la mia domanda viene approvata, NON desidero che il mio nome e indirizzo e-mail vengano inclusi nell'elenco delle risorse dei membri di Tree Cities of the World (disponibile solo per altre comunità riconosciute da Tree Cities of the World).",
    choiceNo: 'No',
    choiceSelect: 'Seleziona',
    choiceYes: 'Sì',
    countrySelect: 'Seleziona il tuo Paese',
    fuzzyMatchContinue: (partnerTerm: string) => `Continua a creare un nuovo ${partnerTerm}`,
    fuzzyMatchMessage:
      'Abbiamo trovato alcuni partner esistenti con nomi simili nel tuo stato. Intendevi uno di questi?',
    fuzzyMatchSelect: 'Seleziona',
    fuzzyMatchTitle: 'Partner simili trovati',
    errorMessageEnd: 'Controlla i valori e reinserisci se necessario.',
    errorMessageStart:
      'Si è verificato un problema con il modulo. Le seguenti domande non hanno un "valore" valido:',
    errorPartnerHeader: 'Dettagli',
    errorPrimaryContactHeader: 'Dettagli contatto principale',
    errorShippingContactHeader: 'Dettagli contatto di spedizione',
    headerAddAccount: 'Aggiungi account',
    headerExistingPartnerDetails: 'Seleziona la tua città',
    headerLabel: 'Informazioni',
    headerPartnerDetails: 'Dettagli nuova città',
    headerPrimaryContact: 'Informazioni sul contatto principale',
    headerProgram: 'Portale di riconoscimento dei programmi',
    headerSelectProgram: 'Cosa stai richiedendo?',
    headerShipping: 'Indirizzo di spedizione predefinito',
    headerSocialMedia: 'Canali social media per la tua ',
    helperCityError: 'Città richiesta',
    helperEmailError: 'Indirizzo e-mail richiesto',
    helperNameError: 'Nome richiesto',
    helperShippingCityError: 'Città di spedizione richiesta',
    helperShippingStreetAddressError: 'Indirizzo di spedizione richiesto',
    helperShippingZipCodeError: 'Inserisci un codice postale di spedizione valido',
    helperStreetAddressError: 'Indirizzo richiesto',
    helperZipCode: 'Inserisci valori numerici',
    helperZipCodeError: 'Codice postale richiesto',
    labelAppliedToADF: (partnerTerm: string, programName: string) =>
      `Non hai trovato la tua ${partnerTerm} o è la prima volta che la tua ${partnerTerm} richiede il riconoscimento ${programName}. Clicca per inserire una nuova ${partnerTerm}.`,
    labelCategory: 'Quale categoria descrive meglio la tua ',
    labelCity: 'Città',
    labelGenericEmail: 'Indirizzo e-mail generico per il ',
    labelName: 'Nome',
    labelPhoneNumber: 'Numero di telefono per',
    labelShippingCity: 'Città di spedizione',
    labelShippingCountry: 'Paese di spedizione',
    labelShippingStreetAddress: 'Indirizzo di spedizione',
    labelShippingStreetAddress2: 'Indirizzo di spedizione 2',
    labelShippingZipCode: 'Codice postale di spedizione',
    labelSubCategoryOther: 'Si prega di specificare:',
    labelTitle: 'Titolo',
    labelZipCode: 'Codice postale',
    messageSubmissionError: "Errore durante l'invio del modulo di registrazione.",
    messageSubmissionSuccess: 'Modulo di iscrizione inviato con successo.',
    partnerSelect: 'Seleziona il tuo ',
    required: 'programma',
    selectProgram: 'Seleziona il programma',
    partnerNotFoundHelperText: (partnerTerm: string) =>
      `Nessun ${partnerTerm} trovato - Seleziona la casella qui sotto per avviare un nuovo ${partnerTerm}`,
    subHeaderExistingPartnerDetails: (partnerTerm: string, programName: string) =>
      `Se la tua ${partnerTerm} ha già presentato domanda per ottenere il riconoscimento ${programName} in passato, cerca la tua ${partnerTerm} utilizzando questo modulo. Se non la trovi, seleziona la casella sottostante per iniziare una nuova ${partnerTerm}.`,
    subHeaderPartnerDetails:
      '"Nota": se intendi presentare domanda per più località, compila il modulo sottostante per una sola località. Potrai aggiungere altre località in un secondo momento.',
    tooltipSubmit: 'Clicca per inviare il modulo di iscrizione.',
  },
  percentQuestion: {
    invalidPercent: 'Il valore deve essere un numero tra 0 e 100.',
  },
  userLoadError: {
    contactUs: 'Contattaci',
    message:
      'Riprova. Se il problema persiste, contattaci indicando il riferimento riportato di seguito.',
    referenceLabel: 'Riferimento',
    signOut: 'Esci',
    title: 'Non è stato possibile caricare il tuo account.',
    tryAgain: 'Riprova',
  },
  userManagement: {
    removeReviewerAssignmentConfirmationModal: {
      header: 'Elimina assegnazione revisore',
      confirmationMessage:
        'Sei sicuro di voler rimuovere questa assegnazione del revisore? Questa azione non può essere annullata.',
      confirmationButtonText: 'Rimuovi assegnazione',
      successMessage: 'Assegnazione revisore rimossa con successo!',
    },
    snackbarError: 'Modifica non riuscita',
    snackbarSuccess: 'Aggiornamento riuscito',
  },
};
